/* Bloc d'offres Oreliva : choix du pack, couleurs, ajouts cochables, ajout au panier en une requête.
   Chaque option du <select> porte data-price / data-compare en centimes. Le format monétaire vient de data-money. */
(function () {
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2), n = v.split('.');
    var thou = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return (fmt || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return thou(String(Math.round(cents / 100)), ',');
      if (k === 'amount_with_comma_separator') return thou(n[0], '.') + ',' + n[1];
      if (k === 'amount_no_decimals_with_comma_separator') return thou(String(Math.round(cents / 100)), '.');
      if (k === 'amount_with_space_separator') return thou(n[0], ' ') + ',' + n[1];
      return thou(n[0], ',') + '.' + n[1];
    });
  }
  function opt(sel) { return sel.options[sel.selectedIndex]; }

  /* Liste de couleurs maison (rendu Kaching) : le <select> reste la source de vérité, invisible. */
  function syncListe(w) {
    var s = w.querySelector('select'), lab = w.querySelector('.okb__sw-l');
    if (!s) return;
    if (lab) lab.textContent = opt(s).text.trim();
    w.querySelectorAll('.okb__dd li').forEach(function (li, i) { li.classList.toggle('is-sel', i === s.selectedIndex); });
  }
  function ferme(sauf) { document.querySelectorAll('.okb__sw.is-open').forEach(function (x) { if (x !== sauf) x.classList.remove('is-open'); }); }
  function liste(w) {
    var s = w.querySelector('select');
    if (!s || w.dataset.dd) return;
    w.dataset.dd = '1';
    var lab = document.createElement('span'); lab.className = 'okb__sw-l'; w.insertBefore(lab, s);
    var ul = document.createElement('ul'); ul.className = 'okb__dd'; ul.setAttribute('role', 'listbox');
    [].forEach.call(s.options, function (o, idx) {
      var li = document.createElement('li'), c = o.getAttribute('data-color');
      li.setAttribute('role', 'option');
      if (o.disabled) li.className = 'is-off';
      li.innerHTML = (c ? '<i style="background:' + c + '"></i>' : '') + '<span></span>';
      li.querySelector('span').textContent = o.text.trim();
      li.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (o.disabled) return;
        s.selectedIndex = idx; s.dispatchEvent(new Event('change', { bubbles: true }));
        w.classList.remove('is-open'); syncListe(w);
      });
      ul.appendChild(li);
    });
    w.appendChild(ul);
    w.addEventListener('click', function (e) {
      if (e.target.closest('.okb__dd')) return;
      e.preventDefault();
      var ouvrir = !w.classList.contains('is-open');
      ferme(w); w.classList.toggle('is-open', ouvrir); syncListe(w);
    });
    syncListe(w);
  }
  document.addEventListener('click', function (e) { if (!e.target.closest('.okb__sw')) ferme(null); });

  function init(root) {
    if (root.dataset.okbReady) return; root.dataset.okbReady = '1';
    var fmt = root.getAttribute('data-money');
    var bars = [].slice.call(root.querySelectorAll('[data-bar]'));
    root.querySelectorAll('.okb__sw').forEach(liste);

    function totals(bar) {
      var qty = parseInt((bar.querySelector('[data-qty-input]') || { value: 1 }).value, 10) || 1;
      var p = 0, c = 0;
      bar.querySelectorAll('[data-line]').forEach(function (s) {
        var o = opt(s), q = (parseInt(s.getAttribute('data-qty'), 10) || 1) * qty;
        p += parseInt(o.dataset.price, 10) * q;
        c += (parseInt(o.dataset.compare, 10) || parseInt(o.dataset.price, 10)) * q;
      });
      bar.querySelectorAll('.okb__sw').forEach(function (w) {
        var s = w.querySelector('select'), i = w.querySelector('i'); if (!s || !i) return;
        var col = opt(s).getAttribute('data-color');
        if (col) { i.style.background = col; i.removeAttribute('data-none'); } else { i.setAttribute('data-none', ''); }
        syncListe(w);
      });
      bar.querySelectorAll('[data-product-row]').forEach(function (row) {
        var s = row.querySelector('[data-line]'); if (!s) return;
        var o = opt(s), pr = parseInt(o.dataset.price, 10), cp = parseInt(o.dataset.compare, 10) || 0;
        row.querySelector('[data-pp]').textContent = money(pr, fmt);
        row.querySelector('[data-pf]').textContent = cp > pr ? money(cp, fmt) : '';
      });
      var pe = bar.querySelector('[data-price]'), ce = bar.querySelector('[data-full]');
      if (pe) pe.textContent = money(p, fmt);
      if (ce) { ce.textContent = c > p ? money(c, fmt) : ''; }
      bar.querySelectorAll('[data-upsell]').forEach(function (u) {
        var s = u.querySelector('select') || u.querySelector('[data-addon-id]');
        var o = s.tagName === 'SELECT' ? opt(s) : s;
        u.querySelector('[data-up-price]').textContent = money(parseInt(o.dataset.price, 10), fmt);
        var f = u.querySelector('[data-up-full]'), cmp = parseInt(o.dataset.compare, 10) || 0;
        if (f) f.textContent = cmp > parseInt(o.dataset.price, 10) ? money(cmp, fmt) : '';
      });
    }

    function select(bar) {
      bars.forEach(function (b) { b.classList.toggle('is-selected', b === bar); b.setAttribute('aria-checked', b === bar); });
    }

    bars.forEach(function (bar) {
      bar.addEventListener('click', function (e) {
        if (e.target.closest('select, input, button, label.okb__upsell')) { if (!bar.classList.contains('is-selected')) select(bar); return; }
        select(bar);
      });
      bar.querySelectorAll('select').forEach(function (s) { s.addEventListener('change', function () { totals(bar); }); });
      var qi = bar.querySelector('[data-qty-input]');
      if (qi) {
        bar.querySelectorAll('[data-qty-step]').forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault();
            qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
            totals(bar);
          });
        });
        qi.addEventListener('change', function () { qi.value = Math.max(1, parseInt(qi.value, 10) || 1); totals(bar); });
      }
      totals(bar);
    });

    var btn = root.querySelector('[data-atc]'), err = root.querySelector('[data-err]');
    btn.addEventListener('click', function () {
      var bar = root.querySelector('[data-bar].is-selected') || bars[0];
      var qty = parseInt((bar.querySelector('[data-qty-input]') || { value: 1 }).value, 10) || 1;
      var items = [];
      bar.querySelectorAll('[data-line]').forEach(function (s) {
        var it = { id: parseInt(s.value, 10), quantity: (parseInt(s.getAttribute('data-qty'), 10) || 1) * qty };
        var prop = s.getAttribute('data-prop');
        if (prop) {
          var src = bar.querySelector('[data-prop-src="' + prop + '"]');
          if (src) { it.properties = {}; it.properties[prop] = opt(src).text.trim(); }
        }
        items.push(it);
      });
      bar.querySelectorAll('[data-upsell]').forEach(function (u) {
        var cb = u.querySelector('input[type=checkbox]');
        if (!u.hasAttribute('data-gift') && (!cb || !cb.checked)) return;
        var s = u.querySelector('select') || u.querySelector('[data-addon-id]');
        var id = s.tagName === 'SELECT' ? s.value : s.getAttribute('data-addon-id');
        items.push({ id: parseInt(id, 10), quantity: 1 });
      });
      btn.disabled = true; err.classList.remove('is-on');
      var drawer = document.querySelector('cart-drawer');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (d.status && d.status !== 200) throw new Error(d.description || d.message || 'Erreur');
        if (window.OrelivaCart) { window.OrelivaCart.open(); return; }
        if (drawer && typeof drawer.renderContents === 'function' && d.sections) {
          try {
            drawer.classList.remove('is-empty');
            d.id = items[0].id;
            drawer.renderContents(d);
            return;
          } catch (e) { /* repli */ }
        }
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }).catch(function (e) {
        err.textContent = e.message || 'Impossible d’ajouter au panier.'; err.classList.add('is-on');
      }).finally(function () { btn.disabled = false; });
    });
  }

  function boot() { document.querySelectorAll('[data-okb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
